import { useState, useCallback } from 'react';

export const useReCaptchaV2 = () => {
  const [isUseRecaptchaV2, setIsUseRecaptchaV2] = useState(false);
  const [captchaV2Token, setCaptchaV2Token] = useState<string | null>(null);
  const [isCaptchaV2Error, setCaptchaV2Error] = useState(false);

  const setCaptchaToken = useCallback((token: string | null) => {
    setCaptchaV2Token(token);
  }, []);

  const showV2Captcha = useCallback(() => {
    setIsUseRecaptchaV2(true);
  }, []);

  const hideV2Captcha = useCallback(() => {
    setIsUseRecaptchaV2(false);
    setCaptchaV2Token(null);
  }, []);

  const setRecaptchaV2Error = useCallback((error: boolean) => {
    setCaptchaV2Error(error);
  }, []);

  return {
    isUseRecaptchaV2,
    captchaV2Token,
    isCaptchaV2Error,
    setRecaptchaV2Error,
    setCaptchaToken,
    showV2Captcha,
    hideV2Captcha,
  };
};
